import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PageLoader: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Smooth splash screen transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-white"
        >
          <div className="text-center px-4">
            {/* Logo with Animated Ring */}
            <div className="relative w-24 h-24 mx-auto mb-5 flex items-center justify-center">
              {/* Spinning gradient ring */}
              <motion.div
                className="absolute inset-0"
                animate={{ rotate: 360 }}
                transition={{
                  duration: 1.8,
                  repeat: Infinity,
                  ease: "linear",
                }}
              >
                <div className="w-full h-full border-[3px] border-purple-100 rounded-full" />
                <div className="absolute inset-0 border-[3px] border-transparent border-t-[#552FB5] border-r-[#0088FF] rounded-full" />
              </motion.div>

              {/* Pulsing SetGo Emblem */}
              <motion.div
                className="relative z-10 w-14 h-14 flex items-center justify-center"
                animate={{
                  scale: [0.94, 1.06, 0.94],
                }}
                transition={{
                  duration: 1.6,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <img
                  src="/setgo-emblem.png"
                  alt="SetGo Logo"
                  className="w-12 h-12 object-contain drop-shadow-md select-none"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "/logo.png";
                  }}
                />
              </motion.div>
            </div>

            {/* SetGo Brand Name & Subtext */}
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.15 }}
            >
              <h2 className="text-2xl font-extrabold text-slate-900 tracking-tight mb-1">
                Setgo
              </h2>
              <p className="text-xs sm:text-sm font-medium text-slate-500">
                Discover Local · Save More · Earn Rewards
              </p>
            </motion.div>

            {/* Animated bouncing dots */}
            <motion.div
              className="mt-5 flex justify-center space-x-1.5"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4, delay: 0.3 }}
            >
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-2 bg-[#552FB5] rounded-full"
                  animate={{
                    scale: [1, 1.4, 1],
                    opacity: [0.5, 1, 0.5],
                  }}
                  transition={{
                    duration: 0.9,
                    repeat: Infinity,
                    delay: i * 0.18,
                  }}
                />
              ))}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { PageLoader };
